import { CustomColumnType } from "../grid-column-types";
import { fontColors, rowColors, tableStyles } from "./constants";
import { language } from "language/default";
const shouldIncludeColumnInExport = (column) => !column.hide && !column.pivot && column.type !== CustomColumnType.AUX_CHECKBOX_COLUMN && !column.skipExcelExport;
const getPivotColumns = (visibleColumns) => {
    const columnsInHeaderFirstRow = [];
    const columnsInHeaderSecondRow = [];
    const pivotKeys = {};
    visibleColumns.forEach((column) => {
        if (column.pivotKeys) {
            const [pivotKey] = column.pivotKeys;
            if (pivotKeys[pivotKey] === undefined) {
                pivotKeys[pivotKey] = 0;
            }
            else {
                pivotKeys[pivotKey] += 1;
            }
            const headerCell = {
                style: tableStyles.TABLE_HEADER,
                text: column.headerName ?? ""
            };
            columnsInHeaderSecondRow.push(headerCell);
        }
        else {
            columnsInHeaderFirstRow.push({ border: [true, true, true, false], text: "" });
            columnsInHeaderSecondRow.push({
                border: [true, false, true, true],
                style: tableStyles.TABLE_HEADER,
                text: column.headerName ?? ""
            });
        }
    });
    Object.keys(pivotKeys).forEach((key) => {
        columnsInHeaderFirstRow.push({
            colSpan: pivotKeys[key] + 1,
            style: tableStyles.TABLE_HEADER,
            text: key
        });
        columnsInHeaderFirstRow.push(...Array.from({ length: pivotKeys[key] }, () => ""));
    });
    return { columnsInHeaderFirstRow, columnsInHeaderSecondRow };
};
const createHeaderRows = (columns, visibleColumns) => {
    const columnsInHeaderFirstRow = [];
    const columnsInHeaderSecondRow = [];
    columns.forEach((column) => {
        const { field } = column;
        const { sort } = column;
        const headerNameUppercase = column.headerName ?? field;
        if (column.children === undefined) {
            columnsInHeaderFirstRow.push({ border: [true, true, true, false], text: "" });
            columnsInHeaderSecondRow.push({
                border: [true, false, true, true],
                style: tableStyles.TABLE_HEADER,
                text: headerNameUppercase + (sort ? ` (${sort})` : ""),
                type: column.type
            });
        }
        else {
            const children = column.children.filter((child) => !child.hide && visibleColumns.some((x) => x.field === child.field));
            if (children.length !== 0) {
                columnsInHeaderFirstRow.push({
                    colSpan: children.length,
                    style: tableStyles.TABLE_HEADER,
                    text: headerNameUppercase + (sort ? ` (${sort})` : "")
                });
                columnsInHeaderFirstRow.push(...Array.from({ length: children.length - 1 }, () => ""));
                children.forEach((child) => {
                    const headerCell = {
                        style: tableStyles.TABLE_HEADER,
                        text: child.headerName
                    };
                    columnsInHeaderSecondRow.push(headerCell);
                });
            }
        }
    });
    return { columnsInHeaderFirstRow, columnsInHeaderSecondRow };
};
export const getHeaderToExport = (gridApi) => {
    const visibleColumns = gridApi?.getAllDisplayedColumns().map((x) => x.colDef) ?? [];
    const isPivot = gridApi.isPivotMode();
    if (isPivot) {
        return getPivotColumns(visibleColumns);
    }
    const columnDefs = gridApi.getColumnDefs().filter(shouldIncludeColumnInExport);
    const columns = (gridApi?.getRowGroupColumns()?.map((x) => ({ ...x, field: language.en.grid.group })) ?? [])
        .concat(columnDefs.filter((x) => x.pinned === "left"))
        .concat(columnDefs.filter((x) => !x.pinned))
        .concat(columnDefs.filter((x) => x.pinned === "right"));
    return createHeaderRows(columns, visibleColumns);
};
export const getFooterToExport = (numberOfRows, numberOfColumns) => {
    const footer = Array(numberOfColumns).fill({ border: [false, false, false, false], fillColor: rowColors.ODD_ROW_COLOR, text: "" });
    footer[0] = { border: [false, false, false, false],
        colSpan: numberOfColumns,
        fillColor: rowColors.ODD_ROW_COLOR,
        text: [{ color: fontColors.SECONDARY_TEXT, text: `Rows: ${numberOfRows}` }] };
    return footer;
};
